import script from "./ClientesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientesView.vue?vue&type=script&setup=true&lang=js"

import "./ClientesView.vue?vue&type=style&index=0&id=0ddadb6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddadb6c"]])

export default __exports__